class jqfixedWindow {
	constructor(elem) {
		this.elem = elem;
	}

	// 背面スクロールを禁止（window.jQuery）
	fixedWindow(elem) {
		window.jQuery(function() {
			if (navigator.userAgent.indexOf("iPhone") > 0 || navigator.userAgent.indexOf("iPod") > 0 || navigator.userAgent.indexOf("iPad") > 0) {
				var ycoord = window.jQuery(window).scrollTop();
				window.jQuery(elem).data("ycoord",ycoord);
				ycoord = ycoord * -1;
				window.jQuery("body").css("position","fixed").css("left","0px").css("right","0px").css("top",ycoord + "px");
			} else {
				window.jQuery("body").css({overflow: "hidden"}); // iOS向け
			}
		});
		return;
	}

	// 背面スクロール禁止を解除
	releaseWindow(elem) {
		window.jQuery(function() {
			if (navigator.userAgent.indexOf("iPhone") > 0 || navigator.userAgent.indexOf("iPod") > 0 || navigator.userAgent.indexOf("iPad") > 0) {
				window.jQuery("body").css("position","").css("left","auto").css("right","auto").css("top","auto");
				window.jQuery(window).scrollTop(window.jQuery(elem).data("ycoord"));
			} else {
				window.jQuery("body").css({overflow: ""}); // iOS向け
			}
		});
		return;
	}

}
export default {jqfixedWindow}